import React, { useState, useEffect } from 'react';
import {
	Grid,
	Typography,
	List,
	ListItem,
	ListItemAvatar,
	ListItemText,
	Alert,
} from '@mui/material';
import { HeaderSection, setColorStyle } from './BiasInfo';
import VisibilityIcon from '@mui/icons-material/Visibility';
import NorthEastIcon from '@mui/icons-material/NorthEast';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import SubjectIcon from '@mui/icons-material/Subject';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import { getFullName, whichAnnotation } from '../../../helpers/utils';
import { formatDateTimeMX } from '../../../helpers/hours';
import { getAnnotations } from '../../../actions/annotation';
import { getAnnotationsOrder } from '../../../actions/orderAnnotation';
import Label from '../../utils/Label';

// ANNOTATIONS LIST
export const AnnotationsColumn = ({ subbias = null, order = null }) => {
	const [annotations, setAnnotations] = useState([]);

	useEffect(() => {
		const mapAnnotations = (data) => {
			return data.map((item) => ({
				...item,
				key: item.key,
				type: whichAnnotation(item.type),
				created_by: item.created_by,
				description: item.description,
				created_at: formatDateTimeMX(item.created_at),
			}));
		};
		if (subbias !== null || order !== null) {
			if (order) {
				getAnnotationsOrder(order.id).then(({ data }) => {
					setAnnotations(mapAnnotations(data.results));
				});
			} else if (!subbias?.newProgresses) {
				if (subbias?.id) {
					getAnnotations(subbias.id).then(({ data }) => {
						setAnnotations(mapAnnotations(data.results));
					});
				}
			}
		}
	}, [subbias]);

	return (
		<Grid
			item
			xs={4}
			style={{
				...setColorStyle('green'),
				height: '100%',
			}}
		>
			{(subbias || order) && (
				<Grid
					container
					// spacing={2}
					style={{
						...setColorStyle('red'),
						height: '100%',
					}}
				>
					<Grid
						item
						xs={12}
						style={{
							...setColorStyle('blue'),
							padding: '15px',
						}}
					>
						<HeaderSection text='Anotaciones' />
						<div
							style={{
								margin: '10px 0 0 0',
								maxHeight: '70vh',
								overflow: 'scroll',
								overflowX: 'hidden',
							}}
						>
							<List dense>
								{/* {subbias.annotations.length > 0 ? ( */}

								{annotations.length > 0 ? (
									<List>
										{annotations.reverse().map((note) => (
											<ListItemNote
												key={note.key}
												note={note}
											/>
										))}
									</List>
								) : (
									<Alert severity='info'>
										{order
											? 'No hay anotaciones'
											: 'Seleccione una talla'}
									</Alert>
								)}
							</List>
						</div>

						<hr />
					</Grid>
				</Grid>
			)}
		</Grid>
	);
};

const whichAvatar = (type) => {
	switch (type) {
		case 'Observación':
			return <VisibilityIcon />;

		case 'Observación':
			return <MyLocationIcon />;

		case 'Estrategia':
			return <NorthEastIcon />;

		case 'Alerta':
			return <NewReleasesIcon />;
		default:
			return <SubjectIcon />;
	}
};

export const ListItemNote = ({ note }) => {
	const avatar = whichAvatar(note?.type);
	return (
		<ListItem alignItems='flex-start' style={{ marging: '10px 0' }}>
			<ListItemAvatar>{avatar}</ListItemAvatar>
			<ListItemText
				primary={`[${
					note.created_by.area?.name || 'Administración'
				}] - ${note.type}`}
				secondary={
					<React.Fragment>
						{note?.is_done !== undefined && (
							<>
								<br />
								<Label
									color={
										note?.is_done ? 'success' : 'warning'
									}
								>
									{note?.is_done
										? 'Completado'
										: 'Por revisar'}
								</Label>
								<br />
							</>
						)}
						<br />{' '}
						<Typography
							sx={{
								display: 'inline',
							}}
							component='span'
							variant='body2'
							color='text.primary'
						>
							{`${getFullName(note.created_by)}`}
						</Typography>
						{` — ${note.description}`}
						<br /> <br /> {note.created_at}
					</React.Fragment>
				}
			/>
		</ListItem>
	);
};
